/* eslint-disable simple-import-sort/imports */
import { ArrowBack, Send } from '@mui/icons-material';
import React, { useState, useRef, useEffect } from 'react';
import { EmojiIconLarge } from 'stream-chat-react';
import EmojiPicker from 'emoji-picker-react';
import attach from 'assets/Images/attachment.png';
import { Button, Tooltip, useMediaQuery } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useTheme } from '@emotion/react';
import { InternalNewMessageModal } from 'components/Common/InternalNewMessageModel';
import MessageIcon from 'components/Icons/MessageIcon';
import { useTranslation } from 'react-i18next';
import UserCommonDialog from './UserCommonDialog';
import MessageThread from './MessageThread';

interface Chat {
  id: number;
  name: string;
  lastMessage: string;
  time: string;
  picture: string;
  statusId: string;
}

interface ChatListsProps {
  showChat: boolean;
  setShowChat: React.Dispatch<React.SetStateAction<boolean>>;
  selectedChat: Chat | undefined; // Corrected type
}

const ChatContainer: React.FC<ChatListsProps> = ({
  showChat,
  setShowChat,
  selectedChat,
}: any) => {
  const messagesData = [
    {
      id: 1,
      sender: 'Leslie Alexander',
      text: 'Hey Olivia, I’ve finished with the requirements doc!',
      time: 'Thursday 11:04 AM',
      type: 'received',
    },
    {
      id: 2,
      sender: 'Katherine Moss',
      text: 'Tech requirements.pdf (1.2 MB)',
      time: 'Thursday 11:04 AM',
      type: 'file',
    },
    {
      id: 3,
      sender: 'You',
      text: 'Awesome! Thanks. I’ll look at this today.',
      time: 'Thursday 11:41 AM',
      type: 'sent',
    },
    {
      id: 4,
      sender: 'Katherine Moss',
      text: 'No rush though — we still have to wait for Lana’s designs.',
      time: 'Thursday 11:44 AM',
      type: 'received',
    },
    {
      id: 5,
      sender: 'Katherine Moss',
      text: 'Hey Olivia, can you please review the latest design when you can?',
      time: 'Today 2:20 PM',
      type: 'received',
    },
    {
      id: 6,
      sender: 'You',
      text: 'Sure thing, I’ll have a look today. They’re looking great!',
      time: 'Today 5:41 PM',
      type: 'sent',
    },
    {
      id: 7,
      sender: 'Katherine Moss',
      text: 'Ok',
      time: 'Just now',
      type: 'received',
    },
  ];
  const { t } = useTranslation('inbox');
  const theme: any = useTheme();
  const underSm = useMediaQuery(theme.breakpoints.down('sm'));
  const [messages, setMessages] = useState(messagesData);
  const [newMessage, setNewMessage] = useState('');
  const [files, setFiles] = useState<File[]>([]);
  const [emojiPickerIsOpen, setEmojiPickerIsOpen] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [openMessageModel, setOpenMessageModel] = useState<boolean>(false);
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const fileRef = useRef<HTMLInputElement | null>(null);
  const messagesEndRef = useRef<HTMLDivElement | null>(null);

  const sendMessage = () => {
    if (newMessage.trim() === '') return;
    setEmojiPickerIsOpen(false);
    setMessages([
      ...messages,
      {
        id: messages.length + 1,
        sender: 'You',
        text: newMessage,
        time: 'Now',
        type: 'sent',
      },
    ]);
    setNewMessage('');
  };

  const handleChange = (e: any) => {
    const value = e.target.files[0];
    console.log(value);
    setFiles((prev) => [...prev, value]);
  };

  const handleUpload = () => {
    if (fileRef.current) {
      fileRef.current.click();
    }
  };

  const adjustTextareaHeight = () => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = 'auto';
      textarea.style.height = `${Math.min(textarea.scrollHeight, 200)}px`;
    }
  };

  useEffect(() => {
    adjustTextareaHeight();
  }, [newMessage]);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [newMessage]);

  const UserUploadAttachment = (file: File, index: number) => {
    if (file.type.startsWith('image/')) {
      return (
        <>
          <img
            src={URL.createObjectURL(file)}
            alt="preview"
            className="h-[60px] w-[60px] rounded-[8px] border-[#D0D5DD] bg-[#fff] object-cover"
            style={{ border: '1px solid #D0D5DD' }}
          />
          <button
            className="absolute right-[-6px] top-[-6px] flex h-[20px] w-[20px] items-center justify-center rounded-[50%] border-0 text-[12px]"
            onClick={() => setFiles(files.filter((_, i) => i !== index))}
          >
            ✕
          </button>
        </>
      );
    }
    if (file.type.startsWith('video') || file.type === 'image/gif') {
      return (
        <>
          <video
            src={URL.createObjectURL(file)}
            className="ml-2 h-[60px] w-[60px] rounded-[8px] border border-[#D0D5DD] bg-[#fff] object-cover"
            style={{ border: '1px solid #D0D5DD' }}
            controls={true}
            loop
          />
          <button
            className="absolute right-[-6px] top-[-6px] flex h-[20px] w-[20px] items-center justify-center rounded-[50%] border-0 text-[12px]"
            onClick={() => setFiles(files.filter((_, i) => i !== index))}
          >
            ✕
          </button>
        </>
      );
    }
    if (file.type.startsWith('application/pdf')) {
      return (
        <>
          <iframe
            className="ifram_doc h-[60px] w-[60px] rounded-[8px] border border-[#D0D5DD] bg-[#fff] object-cover"
            style={{ border: '1px solid #D0D5DD' }}
            src={URL.createObjectURL(file)}
          />
          <button
            className="absolute right-[-6px] top-[-6px] flex h-[20px] w-[20px] items-center justify-center rounded-[50%] border-0 text-[12px]"
            onClick={() => setFiles(files.filter((_, i) => i !== index))}
          >
            ✕
          </button>
        </>
      );
    }

    return <p>{file.name}</p>;
  };

  const toggleEmojiPicker = () => {
    setEmojiPickerIsOpen((prev) => !prev);
  };

  const groupMessagesByDate = (thread: any[]) => {
    const grouped: any[] = [];
    let lastDate: string | null = null;
    thread.forEach((msg) => {
      let msgDate = msg.time.split(' ')[0];
      if (msg.time === 'Just now' || msg.time === 'Now') {
        msgDate = 'Today';
      }
      if (msgDate !== lastDate) {
        grouped.push({ status: 'date-separator', date: msgDate });
        lastDate = msgDate;
      }
      grouped.push(msg);
    });
    return grouped;
  };

  const groupedMessages = groupMessagesByDate(messages);

  return (
    <>
      <div
        className={`flex max-h-[100vh] flex-col lg:max-h-[98vh] ${
          showChat ? 'block' : 'hidden'
        } bg-white lg:block`}
      >
        <div
          className="flex h-[55px] justify-between border-b bg-white p-4"
          style={{ borderBottom: '1px solid #D0D5DD' }}
        >
          <div className="flex gap-4">
            <button
              className="mr-4 border-0 bg-[#fff] text-gray-600 lg:hidden"
              onClick={() => setShowChat(false)}
            >
              <ArrowBack />
            </button>
            {selectedChat?.picture ? (
              <img
                src={selectedChat?.picture}
                alt="Profile"
                className="h-10 w-10 rounded-full"
              />
            ) : (
              <div className="flex h-10 w-10 items-center justify-center rounded-full border bg-[#73B1E9]">
                <div className="text-[24px] font-medium text-white">
                  {selectedChat?.fisrtname?.charAt(0)?.toUpperCase()}
                </div>
              </div>
            )}
            <div className="mt-0 cursor-pointer" onClick={() => setOpen(true)}>
              <p className="m-0 text-[14px] text-[#101828] lg:text-[18px]">
                {selectedChat?.name}
              </p>
              <p className="m-0 text-[12px] text-[#475467] lg:text-[14px]">
                {selectedChat?.statusId
                  ? selectedChat.statusId
                  : selectedChat?.uuid?.slice(0, 8).toUpperCase()}
              </p>
            </div>
            <div
              className="bg-green-100 mt-0  flex items-center rounded-full px-3 py-1 text-sm font-medium text-[#027A48]"
              style={{
                backgroundColor: '#ECFDF3',
                color: '#027A48',
                border: '1px solid #A3D9A5',
                height: '22px',
                gap: '6px',
              }}
            >
              <span
                className="bg-green-500 h-2.5 w-2.5 rounded-full"
                style={{ backgroundColor: '#12B76A' }}
              ></span>
              <span className="text-[12px]">Online</span>
            </div>
          </div>
          <div className="ml-2">
            {underSm ? (
              <Button
                variant="outlined"
                onClick={() => setOpenMessageModel(true)}
                className="border-gray-300 text-neutral-700 hover:bg-gray-100"
                sx={{
                  borderColor: '#D1D5DB',
                  color: '#11AC9E',
                  bgcolor: '#11AC9E',
                  '&:hover': {
                    backgroundColor: '#90BEE6',
                    borderColor: '#D1D5DB',
                  },
                }}
              >
                <MessageIcon />
              </Button>
            ) : (
              <Button
                variant="outlined"
                startIcon={<AddIcon />}
                onClick={() => setOpenMessageModel(true)}
                className="border-gray-300 text-neutral-700 hover:bg-gray-100"
                sx={{
                  borderColor: '#D1D5DB',
                  color: '#374151',
                  '&:hover': {
                    backgroundColor: '#F3F4F6',
                    borderColor: '#D1D5DB',
                  },
                }}
              >
                {t('newMessage')}
              </Button>
            )}
          </div>
        </div>
        <div className="h-[calc(100%-90px)] ">
          <div className="flex h-[calc(100%-175px)] flex-col overflow-y-auto p-4 sm:overflow-x-auto lg:h-[calc(100%-150px)] lg:overflow-x-hidden">
            {groupedMessages.map((msg, index) =>
              msg.status === 'date-separator' ? (
                <div
                  key={index}
                  className="my-4 flex flex-row justify-center gap-2"
                >
                  <hr className="m-0 mt-2 h-0 w-full text-[#EAECF0]" />
                  <p className="m-0 mb-4 items-center text-[14px] font-[500] text-[#475467]">
                    {msg.date}
                  </p>
                  <hr className="m-0 mt-2 h-0 w-full text-[#EAECF0]" />
                </div>
              ) : (
                <MessageThread key={msg.id || index} msg={msg} />
              )
            )}
            {/* {messages.map((msg) => (
              <MessageThread msg={msg} />
            ))} */}
            <div ref={messagesEndRef} />
          </div>
          {/* Message Input */}
          <div className="flex items-center border-t bg-white px-4">
            <div
              className="relative flex h-[55px] w-full rounded-lg border p-[5px] lg:h-[90px]"
              style={{ border: '1px solid #D0D5DD' }}
            >
              <div className="absolute top-[-70px] flex items-center gap-[10px]">
                {files.map((file, index) => (
                  <div key={index} className="relative inline-block">
                    {UserUploadAttachment(file, index)}
                  </div>
                ))}
              </div>
              <input
                type="file"
                ref={fileRef}
                className="hidden"
                onChange={handleChange}
              />
              <textarea
                ref={textareaRef}
                className="m-0 h-[40px] max-h-[50px] w-full resize-none overflow-y-auto rounded-lg border-0 p-2 text-[14px] focus:outline-none focus:ring-0 md:h-[50px] lg:max-h-[85px] lg:text-[16px]"
                placeholder="Type your message"
                value={newMessage}
                onChange={(e) => setNewMessage(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && sendMessage()}
                onFocus={() => setEmojiPickerIsOpen(false)}
              />
              <div className="relative">
                {emojiPickerIsOpen && (
                  <div className="absolute bottom-[98px] left-[-165px]">
                    <EmojiPicker
                      className="!h-[400px] !w-[300px]"
                      onEmojiClick={(emoji) =>
                        setNewMessage((prev) => prev + emoji.emoji)
                      }
                    />
                  </div>
                )}
                <Tooltip
                  title={
                    emojiPickerIsOpen
                      ? 'Close emoji picker'
                      : 'Open emoji picker'
                  }
                  arrow
                  placement="top"
                >
                  <button
                    type="button"
                    className="str-chat__input-flat-emojiselect ml-2 mt-6 h-[40px] border-0 bg-transparent lg:mt-10"
                    onClick={toggleEmojiPicker}
                  >
                    <EmojiIconLarge />
                  </button>
                </Tooltip>
              </div>
              <button
                type="button"
                className="mt-6 h-[40px] border-0 bg-transparent lg:mt-10"
                onClick={handleUpload}
              >
                <img src={attach} className="h-[20px] w-[20px]" />
              </button>
              <button
                type="button"
                onClick={sendMessage}
                disabled={!newMessage}
                className={`${
                  !newMessage ? 'cursor-not-allowed' : ''
                } mt-[30px] h-[20px] border-0 bg-transparent lg:mt-[45px]`}
              >
                <Send
                  onClick={sendMessage}
                  sx={{ color: '#11AC9E', ml: 2 }}
                  className="text-[#11AC9E]"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
      <UserCommonDialog
        open={open}
        onClose={() => setOpen(false)}
        selectedChat={selectedChat}
      />
      <InternalNewMessageModal
        open={openMessageModel}
        onOpenChange={setOpenMessageModel}
      />
    </>
  );
};

export default ChatContainer;
